import { useEffect } from "react";
import useDarkMode from "../atoms/useDarkMode";

const useDarkModeHook = () => {
  const [darkMode] = useDarkMode();

  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
  }, [darkMode]);
};

export default useDarkModeHook;
